import { v4 as r } from "./index44.js";
import { dset as s } from "./index45.js";
import { CoreLogger as l } from "./index76.js";
import { NullStats as u } from "./index63.js";
var f = (
  /** @class */
  /* @__PURE__ */ function() {
    function e(t) {
      var o, i, n;
      this.retry = (o = t.retry) !== null && o !== void 0 ? o : !0, this.type = (i = t.type) !== null && i !== void 0 ? i : "plugin Error", this.reason = (n = t.reason) !== null && n !== void 0 ? n : "";
    }
    return e;
  }()
), c = (
  /** @class */
  function() {
    function e(t, o, i, n) {
      o === void 0 && (o = r()), i === void 0 && (i = new u()), n === void 0 && (n = new l()), this.attempts = 0, this.event = t, this._id = o, this.logger = n, this.stats = i;
    }
    return e.system = function() {
    }, e.prototype.isSame = function(t) {
      return t.id === this.id;
    }, e.prototype.cancel = function(t) {
      throw t || new f({ reason: "Context Cancel" });
    }, e.prototype.log = function(t, o, i) {
      this.logger.log(t, o, i);
    }, Object.defineProperty(e.prototype, "id", {
      get: function() {
        return this._id;
      },
      enumerable: !1,
      configurable: !0
    }), e.prototype.updateEvent = function(t, o) {
      var i;
      if (t.split(".")[0] === "integrations") {
        var n = t.split(".")[1];
        if (((i = this.event.integrations) === null || i === void 0 ? void 0 : i[n]) === !1)
          return this.event;
      }
      return s(this.event, t, o), this.event;
    }, e.prototype.failedDelivery = function() {
      return this._failedDelivery;
    }, e.prototype.setFailedDelivery = function(t) {
      this._failedDelivery = t;
    }, e.prototype.logs = function() {
      return this.logger.logs;
    }, e.prototype.flush = function() {
      this.logger.flush(), this.stats.flush();
    }, e.prototype.toJSON = function() {
      return {
        id: this._id,
        event: this.event,
        logs: this.logger.logs,
        metrics: this.stats.metrics
      };
    }, e;
  }()
);
export {
  f as ContextCancelation,
  c as CoreContext
};
//# sourceMappingURL=index43.js.map
